import { AxiosInstance } from "axios";
import { ICartItem, PaymentMethod } from "types/cart";
import { IOrder } from "types/order";

const transactionUrl = "transaction";

class TransactionApi {
	http: AxiosInstance;
	constructor(axiosInstance: AxiosInstance) {
		this.http = axiosInstance;
	}

	create = (cartItems: ICartItem[], paymentMethod: PaymentMethod) => {
		return this.http.post(transactionUrl, { items: cartItems, paymentMethod });
	};

	createForUser = (
		userId: string,
		cartItems: ICartItem[],
		signatureImg: string,
		paymentMethod: PaymentMethod,
		discountRate: number | undefined
	) => {
		return this.http.post<IOrder>(transactionUrl + "/other/" + userId, { items: cartItems, paymentMethod, signatureImg, discountRate });
	};

	guestCreate = (cartItems: ICartItem[], paymentMethod: PaymentMethod, discountRate?: number) => {
		return this.http.post(transactionUrl + "/walk-in", { items: cartItems, paymentMethod, discountRate });
	};
}

export default TransactionApi;
